import React from 'react'

const Question = () => <div>this is a question</div>

export default Question
